import { Pipe, PipeTransform } from '@angular/core';
import {
  UntypedFormControl,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';

@Pipe({
  name: 'validateField',
  pure: false,
})
export class ValidationPipe implements PipeTransform {
  transform(abstractControl :AbstractControl | null) :string | null {
    const control = abstractControl as UntypedFormControl;

    if (
      control?.invalid &&
      control?.errors &&
      (control?.dirty || control?.touched)
    ) {
      if (control.hasError('required')) {
        return 'This field is required';
      }
      if (control.hasError('min')) {
        return `The field value must be greater than or equal to ${control.errors['min']?.min}`;
      }
      if (control.hasError('max')) {
        return `The field value must be less than or equal to ${control.errors['max']?.max}`;
      }
      if (control.hasError('minlength')) {
        return `The field value is too short`;
      }
      if (control.hasError('maxlength')) {
        return `The field value exceeds the max length`;
      }
      if (control.hasError('ccNumber')) {
        return `Invalid card number`;
      }
      if (control.hasError('expDate')) {
        return `Invalid expiration date`;
      }
    }

    return null;
  }
}
